import { Formik, getIn } from "formik";
import { rideSchema } from "../../schemas/rideSchema";
import {
  TextField,
  Button,
  IconButton,
  FormControlLabel,
  Switch,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import Card from "@mui/material/Card";
import { MdClose } from "react-icons/md";

export const RideForm = ({ open, onClose, handleUpdate, ride = null }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="flex items-center justify-center p-4 backdrop-blur-sm bg-black/40"
      closeAfterTransition
    >
      <Card className="w-full max-w-4xl overflow-hidden rounded-xl shadow-2xl bg-white border-0 flex flex-col max-h-[90vh]">
        {/* Header */}
        <div className="px-6 py-4 flex justify-between items-center bg-gray-50/30 border-b border-gray-100">
          <h2 className="text-xl font-bold text-gray-800">Edit Ride</h2>
          <IconButton
            onClick={onClose}
            className="hover:bg-red-50 hover:text-red-500 transition-colors p-1"
          >
            <MdClose />
          </IconButton>
        </div>

        <Formik
          initialValues={{
            id: ride?.id || "",
            transportationProviderId: ride?.transportationProviderId || "",
            // webhookURL: ride?.webhookURL || "",
            levelOfService: ride?.levelOfService || "",
            appointmentTime: ride?.appointmentTime || "",
            billableAmount: ride?.billableAmount || "",
            billableMiles: ride?.billableMiles || "",
            // billingRequired: ride?.billingRequired || false,
            willCall: ride?.willCall || false,
            rider: {
              firstName: ride?.rider?.firstName || "",
              lastName: ride?.rider?.lastName || "",
            },
            pickup: {
              scheduledTime: ride?.pickup?.scheduledTime || "",
              address: {
                addressLine1: ride?.pickup?.address?.addressLine1 || "",
                addressLine2: ride?.pickup?.address?.addressLine2 || "",
                city: ride?.pickup?.address?.city || "",
                state: ride?.pickup?.address?.state || "",
                zipCode: ride?.pickup?.address?.zipCode || "",
              },
            },
            dropoff: {
              scheduledTime: ride?.dropoff?.scheduledTime || "",
              address: {
                addressLine1: ride?.dropoff?.address?.addressLine1 || "",
                addressLine2: ride?.dropoff?.address?.addressLine2 || "",
                city: ride?.dropoff?.address?.city || "",
                state: ride?.dropoff?.address?.state || "",
                zipCode: ride?.dropoff?.address?.zipCode || "",
              },
            },
          }}
          enableReinitialize={true}
          validationSchema={rideSchema}
          onSubmit={(values, { setSubmitting }) => {
            handleUpdate(values).finally(() => {
              setSubmitting(false);
            });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form
              onSubmit={handleSubmit}
              className="flex flex-col flex-1 overflow-hidden"
            >
              <div className="p-8 space-y-8 overflow-y-auto flex-1">
                {/* Rider Details */}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
                  {/* Rider Details */}
                  <TextField
                    fullWidth
                    label="ID"
                    name="id"
                    value={values.id}
                    size="small"
                    onChange={handleChange}
                    error={touched.id && Boolean(errors.id)}
                    helperText={touched.id && errors.id}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* first name */}
                  <TextField
                    fullWidth
                    label="Rider First Name"
                    name="rider.firstName"
                    value={values.rider.firstName}
                    size="small"
                    onChange={handleChange}
                    error={
                      getIn(touched, "rider.firstName") &&
                      Boolean(getIn(errors, "rider.firstName"))
                    }
                    helperText={
                      getIn(touched, "rider.firstName") &&
                      getIn(errors, "rider.firstName")
                    }
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* last name */}
                  <TextField
                    fullWidth
                    label="Rider Last Name"
                    name="rider.lastName"
                    value={values.rider.lastName}
                    size="small"
                    onChange={handleChange}
                    error={
                      getIn(touched, "rider.lastName") &&
                      Boolean(getIn(errors, "rider.lastName"))
                    }
                    helperText={
                      getIn(touched, "rider.lastName") &&
                      getIn(errors, "rider.lastName")
                    }
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* transportation provider id */}
                  <TextField
                    fullWidth
                    label="Transportation Provider ID"
                    name="transportationProviderId"
                    value={values.transportationProviderId}
                    size="small"
                    onChange={handleChange}
                    error={
                      touched.transportationProviderId &&
                      Boolean(errors.transportationProviderId)
                    }
                    helperText={
                      touched.transportationProviderId &&
                      errors.transportationProviderId
                    }
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* level of service */}
                  <TextField
                    fullWidth
                    label="Level of Service"
                    name="levelOfService"
                    value={values.levelOfService}
                    size="small"
                    onChange={handleChange}
                    error={
                      touched.levelOfService && Boolean(errors.levelOfService)
                    }
                    helperText={touched.levelOfService && errors.levelOfService}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />

                  {/* appointment time */}
                  <TextField
                    fullWidth
                    label="Appointment Time"
                    name="appointmentTime"
                    value={values.appointmentTime}
                    size="small"
                    onChange={handleChange}
                    error={
                      touched.appointmentTime && Boolean(errors.appointmentTime)
                    }
                    helperText={
                      touched.appointmentTime && errors.appointmentTime
                    }
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                    placeholder="YYYY-MM-DDTHH:mm:ss"
                  />

                  {/* address line 1 */}
                  <TextField
                    fullWidth
                    label="Pickup Address Line 1"
                    name="pickup.address.addressLine1"
                    value={values.pickup.address.addressLine1}
                    size="small"
                    onChange={handleChange}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* address line 2 */}
                  <TextField
                    fullWidth
                    label="Pickup Address Line 2"
                    name="pickup.address.addressLine2"
                    value={values.pickup.address.addressLine2}
                    size="small"
                    onChange={handleChange}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* city */}
                  <TextField
                    fullWidth
                    label="City"
                    name="pickup.address.city"
                    value={values.pickup.address.city}
                    size="small"
                    onChange={handleChange}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* state */}
                  <TextField
                    fullWidth
                    label="State"
                    name="pickup.address.state"
                    value={values.pickup.address.state}
                    size="small"
                    onChange={handleChange}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* zip code */}
                  <TextField
                    fullWidth
                    label="Zip Code"
                    name="pickup.address.zipCode"
                    value={values.pickup.address.zipCode}
                    size="small"
                    onChange={handleChange}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* scheduled time */}
                  <TextField
                    fullWidth
                    label="Pickup Scheduled Time"
                    name="pickup.scheduledTime"
                    value={values.pickup.scheduledTime}
                    size="small"
                    onChange={handleChange}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                    placeholder="YYYY-MM-DDTHH:mm:ss"
                  />

                  {/* address line 1 */}
                  <TextField
                    fullWidth
                    label="Dropoff Address Line 1"
                    name="dropoff.address.addressLine1"
                    value={values.dropoff.address.addressLine1}
                    size="small"
                    onChange={handleChange}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* address line 2 */}
                  <TextField
                    fullWidth
                    label="Dropoff Address Line 2"
                    name="dropoff.address.addressLine2"
                    value={values.dropoff.address.addressLine2}
                    size="small"
                    onChange={handleChange}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* city */}
                  <TextField
                    fullWidth
                    label="City"
                    name="dropoff.address.city"
                    value={values.dropoff.address.city}
                    size="small"
                    onChange={handleChange}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* state */}
                  <TextField
                    fullWidth
                    label="State"
                    name="dropoff.address.state"
                    value={values.dropoff.address.state}
                    size="small"
                    onChange={handleChange}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* zip code */}
                  <TextField
                    fullWidth
                    label="Zip Code"
                    name="dropoff.address.zipCode"
                    value={values.dropoff.address.zipCode}
                    size="small"
                    onChange={handleChange}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* scheduled time */}
                  <TextField
                    fullWidth
                    label="Dropoff Scheduled Time"
                    name="dropoff.scheduledTime"
                    value={values.dropoff.scheduledTime}
                    size="small"
                    onChange={handleChange}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                    placeholder="YYYY-MM-DDTHH:mm:ss"
                  />

                  {/* billable amount */}
                  <TextField
                    fullWidth
                    label="Billable Amount"
                    name="billableAmount"
                    type="number"
                    value={values.billableAmount}
                    size="small"
                    onChange={handleChange}
                    error={
                      touched.billableAmount && Boolean(errors.billableAmount)
                    }
                    helperText={touched.billableAmount && errors.billableAmount}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                  {/* billable miles */}
                  <div className="flex items-center gap-6">
                    <TextField
                      fullWidth
                      label="Billable Miles"
                      name="billableMiles"
                      type="number"
                      value={values.billableMiles}
                      size="small"
                      onChange={handleChange}
                      error={
                        touched.billableMiles && Boolean(errors.billableMiles)
                      }
                      helperText={touched.billableMiles && errors.billableMiles}
                      variant="outlined"
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                      sx={{ flex: 1.5 }}
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={values.willCall}
                          onChange={(e) =>
                            setFieldValue("willCall", e.target.checked)
                          }
                          name="willCall"
                          color="primary"
                        />
                      }
                      label="Will Call"
                      sx={{ flex: 1, whiteSpace: "nowrap" }}
                    />
                  </div>
                  {/* webhook url */}
                  {/* <TextField
                    fullWidth
                    label="Webhook URL"
                    name="webhookURL"
                    value={values.webhookURL}
                    size="small"
                    onChange={handleChange}
                    error={touched.webhookURL && Boolean(errors.webhookURL)}
                    helperText={touched.webhookURL && errors.webhookURL}
                    variant="outlined"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  /> */}
                  {/* billing required */}
                </div>
              </div>

              <div className="flex justify-end gap-3 p-6 border-t border-gray-100 bg-gray-50/30">
                <Button
                  onClick={onClose}
                  sx={{ textTransform: "none", fontWeight: "bold" }}
                  className="px-6 py-2 text-gray-600 hover:bg-gray-100 normal-case font-semibold rounded-lg"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={isSubmitting}
                  sx={{ textTransform: "none", fontWeight: "bold" }}
                  className="bg-[#136F63] hover:bg-[#136F63]/80 text-white px-10 py-2 rounded-lg shadow-md hover:shadow-lg transition-all normal-case font-semibold"
                >
                  Update
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Card>
    </Modal>
  );
};
